import { useTranslation } from 'react-i18next';

import { breakpoints } from '@pulse-web-ui/theme';

import type { Profile } from '@entities/agent-contract';

import { useIsDesktop } from '@shared/hooks';
import { Section } from '@shared/index';

import { useGetProfileSectionHeaderStyles } from '../../hooks';
import type { AgentProfileSectionProps } from '../../model';
import { getAddressTranslations, getAdresses } from '../../utils';

interface AddressSectionProps extends AgentProfileSectionProps {
  addresses?: Profile['addressesAgents'];
  addressesToCompare?: Profile['addressesAgents'];
}

export const AddressSection = ({
  addresses,
  addressesToCompare,
  isRenderTitle,
  isSubmitSection,
  buttonProps,
}: AddressSectionProps) => {
  const { t } = useTranslation();

  const isDesktop = useIsDesktop(breakpoints.DESKTOP);
  const dataLabels = getAddressTranslations(t);

  const data = getAdresses(addresses);
  const dataToCompare = addressesToCompare && getAdresses(addressesToCompare);

  const header = useGetProfileSectionHeaderStyles({
    title: isRenderTitle ? t('AGENT_PROFILE:headers.addresses') : undefined,
    isDesktop,
    isSubmitSection,
    buttonProps,
  });

  return (
    <Section
      data={data}
      dataToCompare={dataToCompare}
      dataLabels={dataLabels}
      header={header}
    />
  );
};
